import Routes from 'ContentUtils/Routes';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIDropdown from 'UIComponents/dropdown/UIDropdown';
import UIDropdownDivider from 'UIComponents/dropdown/UIDropdownDivider';
import UILink from 'UIComponents/link/UILink';
import UIList from 'UIComponents/list/UIList';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const i18nKey = key => `ContentComponents.cmv2.fields.form.${key}`;
const FormActionsDropdown = ({
  formId,
  hasFormsWriteAccess
}) => {
  return /*#__PURE__*/_jsx(UIDropdown, {
    "data-selenium": "form-actions-dropdown",
    buttonSize: "small",
    buttonClassName: "m-right-6",
    buttonText: /*#__PURE__*/_jsx(FormattedMessage, {
      message: i18nKey('actions')
    }),
    children: /*#__PURE__*/_jsxs(UIList, {
      children: [/*#__PURE__*/_jsx(UILink, {
        "data-selenium": "form-actions-dropdown-view-submissions",
        disabled: !hasFormsWriteAccess,
        external: true,
        href: Routes.formSubmissions(formId),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('viewSubmissions')
        })
      }), /*#__PURE__*/_jsx(UILink, {
        "data-selenium": "form-actions-dropdown-go-to-editor",
        disabled: !hasFormsWriteAccess,
        external: true,
        href: Routes.formsEditor2({
          formId
        }),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('editor')
        })
      }), /*#__PURE__*/_jsx(UIDropdownDivider, {}), /*#__PURE__*/_jsx(UILink, {
        "data-selenium": "form-actions-dropdown-form-create",
        disabled: !hasFormsWriteAccess,
        external: true,
        href: Routes.newForm(),
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: i18nKey('create')
        })
      })]
    })
  });
};
export default FormActionsDropdown;